import React, { useEffect } from "react";
import {
  configureSocialEnv,
  setAuthContext,
  setSocialEnv,
} from "@aauti/social-core";
import siteConfig from "config/site.config";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "redux/store";
import { SET_SOCIAL_AUTH } from "types/actions/Social.action";
import { useHistory } from "react-router-dom";

const HardReloadDataUpdate = () => {
  const { socialAuthData } = useSelector<AppState, AppState["SocialAuthData"]>(
    ({ SocialAuthData }) => SocialAuthData
  );
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const publicKey = `-----BEGIN PRIVATE KEY-----
      MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCyyLy3MjBL9HPz
      fhGEEbcx5p688tUqSRGq//XQPbSSk1mjhlOyUIEj28oXr2sOVQC4YmBAT44d36Qa
      DrDivLfXAplKSiXoHesOJlT/JBQkSfcuxxRFKmKfdsbbMYJhQqhI7YD2k7WEmHBU
      rkmq0QIjfq4Aq5BNKsFi1kGnYos0EgxgQgm0HnAFuCkMzdqsUJC0Je/tOi62j+TW
      kAbgAYl4JvWw1yFcWaj5YFkm5tbzncBIz3hH1MleElZkSnKbp6db5WeAZOetiUHn
      Tu7ffCeaYE1hOtQQMtuKnz5zlfgbluHA4uYOcJipwg6Ot56ZHt8gL8UkRKCGy+le
      XUJSPcGlAgMBAAECggEAA+q8S7fd8VlmjZqg+pztamVMQVqBS2m0vo4uDgUUEYld
      6ORsAqzwhLRviIuk06MOyXtfnXkWECx9VWl7UZ8N2LhAsIJ7CHYDV4OFJYkzpxnh
      wFTHP76ue3eS4sGCbZa+xh5B+Y+skJOgaRKKdaNvobnISSZ5Gl+0mJxAwvs4johJ
      +nl3d6nV9BpcrwxWvReb1lkfHrfiNPemcVm8SEsYLL0jB0MFvjx5cEILb67SjvL1
      WOkGX6LLev/9eIRBwoH9pmudaZAfHqQCCy32uDL4a8j6VMCDMfThtcYmOCi2RXQ6
      BAtba/o+4ieq37XfAOYBQOT8LcSADOyTiyjZMqel3wKBgQDf7AcFXJcV8Cznnn6w
      sQ/62IuCkh4jvYfYHcuNutSV353uH6xFtMC2XZ3n7FiCgT+DM6HBdu3nNyr3yoHn
      dmqWgAz7fgQqbak619PZOFpPvSNqHcoSKNx9a8OCwlEmgtuBm78JNOmowmAT7dld
      oUygB6v0CQRTDksLRFTW/uihhwKBgQDMZVpRXw1ZNB/fJcySeU2sPcp7pd+VvdVu
      KLvcmSXa7pDbR3aw/xI3NcdPjNJ0V7XRLdXpzx5fFVFAYPTM2+KsKxvvloisl3vS
      yXgwwRHdUOi2YbBq7nwyFX5HXDwneY+FTPtOkjWhWn3vr2KZQ7akroGqC3hRu8lh
      Ipw4bA2+cwKBgGcOJ8UN8fME0IXg6gnD08js9Hgpa3mjduu9+rrF66T2f6biKNUD
      9VV5DH16xtl5RpPJpX52j9NEDqBwMQ0n8LJHSLJOMvib87DDOBrW1qmwMKZcA24M
      JD4M5LQ/Xj3NJ90kou1Hzun+W12Qr+Npouxb24W6yKS5BUywLCOuub3tAoGBAIEk
      iKxhIk36YSjc+SSTAECTyhvV8i7qgq/XjNsU6JYrpdrmjFfI0fmQQR5CG7bmtDo2
      e7H+63GoRm4m1IWbaNzfYAdBVZm3HMVSBl7HnkH3nRGfJ5holpAOhHsSC+/lHola
      2m4Kc1g/lNKcPfAYmI30tHh8RsldnR+CfrInk4eBAoGAPJYHRcFPmt8s8+nJxREy
      i82m7FLHDKJRVf3II/2KBgnIfgwz2Nhe4vhW99p/QohxmyKBusfSkcPAgso6DEhf
      ZJo4TdCWPXFL7bRXBqR4fRmcA58qou/dT+Miuu6hIGA1BRxJiWr53B7Vdaob3Ta3
      5T7rOMDIoFwkowcNDmH08TY=
    -----END PRIVATE KEY-----`;
    let data = {
      ...socialAuthData,
      privateKeyPem: publicKey,
      tenantId: siteConfig?.tenantId,
    };
    setSocialEnv(siteConfig?.environmentType as any);
    configureSocialEnv({
      SOCIAL_API_URL: siteConfig.socialCoreApiUrl,
      SOCIAL_TENANT_ID: siteConfig.tenantId,
    });
    dispatch({ type: SET_SOCIAL_AUTH, socialAuthData: data });
    setAuthContext(data);
  }, [history?.location?.pathname]);

  useEffect(() => {
    // Check if the page was reloaded
    const wasReloaded = localStorage.getItem("pageReloaded");

    // Listen for key combinations for a hard reload (Ctrl + Shift + R or Cmd + Shift + R)
    const handleKeyDown = (event) => {
      const isCtrlShiftR =
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        (event.key === "R" || event.key === "r"); // Ctrl + Shift + R or Cmd + Shift + R

      if (isCtrlShiftR) {
        // Set the reload flag in localStorage for next time the page reloads
        localStorage.setItem("pageReloaded", "true");
      }
    };
    // Add event listener to detect key press (Ctrl + Shift + R or Cmd + Shift + R)
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      // Clean up event listener
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  // Return null to render nothing
  return null;
};

export default HardReloadDataUpdate;
